module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137511-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_137511-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847675026_tableofcontents"
    }
  }, [_vm._v("THE SPREAD OF IAN NICOL")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_137511-00002"
    }
  }, [_vm._v("One day Ian Nicol, a riveter by trade, started to split in two down the middle. The process began as a bald patch on the back of his head. For a week he kept smearing it with hair restorer, yet it grew bigger, and the surface became curiously puckered and so unpleasant to look upon that at last he went to his doctor. “What is it?” he asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137511-00003"
    }
  }, [_vm._v("“I don’t know,” said the doctor, “but it looks like a face, ha, ha! How do you feel these days?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137511-00004"
    }
  }, [_vm._v("“Fine. Sometimes I get a stabbing pain in my chest and stomach but only in the morning.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137511-00005"
    }
  }, [_vm._v("“Eating well?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137511-00006"
    }
  }, [_vm._v("“Enough for two men.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137511-00007"
    }
  }, [_vm._v("The doctor thumped him all over with a stethoscope and said, “I’m going to have you X-rayed. And I may need to call in a specialist.”")]), _vm._v(" "), _c('div', {
    staticClass: "media image align-center width-auto",
    attrs: {
      "id": "rw-media-image_137511-00001"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "4-1.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137511-00001"
    }
  }, [_vm._v("Over the next three weeks the bald patch grew bigger still and the suggestion of a face more clearly marked on it. Ian visited his doctor and found a specialist in the consulting room, examining X-ray plates against the light. “No doubt about it, Nicol,” said the specialist, “you are "), _c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("splitting in two down the middle.”\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137511-00008"
    }
  }, [_vm._v("Ian considered this.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137511-00009"
    }
  }, [_vm._v("“That’s not usual, is it?” he asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137511-00010"
    }
  }, [_vm._v("“Oh, it happens more than you would suppose. Among bacteria and viruses it’s very common, though it’s certainly less frequent among riveters. I suggest you go into hospital where the process can complete itself without annoyance for your wife or embarrassment to yourself. Think it over.”")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_137511-00001"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137511-00002"
    }
  }, [_vm._v("Ian thought it over and went into hospital where he was put into a small ward and given a nurse to attend him, for the specialist was interested in the case. As the division proceeded more specialists were called in to see what was happening. At first Ian ate and drank with a greed that appalled those who saw it. After consuming three times his normal bulk for three days on end he fell into a coma which lasted till the split was complete. Gradually the lobes of his brain separated and a bone shutter formed between them. The face on the back of his head grew eyelashes and a jaw. What seemed at first a cancer of the heart became another heart. Convulsively the spine doubled itself. In a puzzled way the specialists charted the stages of the process and discussed the cause. A German consultant said that life was freeing itself from the vicissitudes of sexual reproduction. A psychiatrist said it was a form of schizophrenia, a psycho-analyst that it was an ordinary twinning process which had been delayed by a severe case of prenatal sibling rivalry. When the split was complete, two thin Ian Nicols lay together on the bed.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_137511-00002"
    }
  })]), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137511-00003"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("The resentment each felt for the other had not been foreseen or guarded against. In bed the original Ian Nicol could be recognized by his position (he lay ")]), _c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("on the right of the bed), but as soon as both men were strong enough to walk each claimed ownership of birth certificate, union card, clothes, wife and National Insurance benefit. One day in the hospital grounds they started fighting. They were evenly matched and there are conflicting opinions about who won. On leaving hospital they took legal action against each other for theft of identity. The case was resolved by a medical examination which showed that one of them had no navel.\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_c('div', {
    staticClass: "media image align-center width-auto",
    attrs: {
      "id": "rw-media-image_137511-00002"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "6-1.png"
    }
  })])])]), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137511-00004"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("The second Ian Nicol changed his name by deed poll and is now called Macbeth. Sometimes he and Ian Nicol write to each other. The latest news is that each has a bald patch on the  back of his head.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_c('div', {
    staticClass: "media image align-center width-auto",
    attrs: {
      "id": "rw-media-image_137511-00003"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "7-1.png"
    }
  })])])])]), _c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ee566f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847675026_chapter_02.vue
// module id = 84
// module chunks = 0